<!--
弹窗组件
-->
<template>
  <v-snackbar></v-snackbar>
</template>

<script>
export default {

}
</script>